import api from '@/helpers/api'

const API_READ = `/api/inject-point-member/`;
const API_UPDATE = API_READ;
const API_CREATE = API_READ;
const API_DELETE = API_READ;
const API_EXPORT = `/api/inject-point-member/export`;

export default {
  namespaced: true,
  state: {
    status: '',
    injectPointMembers: [],
    pointplans: [],
    currUser: {},
    errMessage: '',
    meta: {
      page: 1,
      limit: 10,
      total: 1
    },
    filter: {},
    search: {},
    summary: {
      total_records: 0,
      total_top_up_points: 0,
      total_deduction_points: 0
    }
  },
  mutations: {
    request(state) {
      state.status = 'loading';
    },
    read(state, { injectPointMembers }) {
      state.injectPointMembers = [...injectPointMembers];
    },
    setPointPlans(state, { pointplans }) {   // mutasi baru untuk pointplans
      state.pointplans = [...pointplans];
    },
    error(state) {
      state.status = 'error';
    },
    success(state) {
      state.status = 'success';
    },
    read_single_success(state, { injectPointMembers }) {
      state.injectPointMembers = injectPointMembers;
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta };
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    setSummary(state, { summary }) {
      state.summary = { ...summary };
    },
    reset_meta(state) {
      state.meta = {
        page: 1,
        limit: 10,
        total: 1
      };
    },
    export(state, { injectPointMembers }) {
      state.injectPointMembers = [...injectPointMembers];
    },
  },
  actions: {
    export({ commit, state }) {
      commit('request');

      const { filter } = state;
      const { search } = state;
      const { sort } = state;

      return new Promise((resolve, reject) => {
        api.request('get', `${API_EXPORT}`, { filter, search, sort }, { responseType: 'blob' })
          .then((result) => {
            return resolve(result);
          }).catch(() => {
            commit('error');
            return reject();
          });
      });
    },
    read({ commit, state }) {
      commit('request');
      const { meta } = state;
      const { filter } = state;
      const { search } = state;

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, filter, search })
          .then((result) => {
            commit('read', { injectPointMembers: result.data.data.inject_point });
            commit('setPointPlans', { pointplans: result.data.data.point_plans || [] });
            commit('setSummary', { summary: result.data.summary || {} });
            commit('success');
            commit('switch_page', { meta: { ...result.data.meta } });
            return resolve();
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },
    delete({ commit }, id) {
      commit('request');

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_DELETE}${id}`, {})
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            console.log(err.response.data);
            commit('error');
            return reject(err);
          });
      });
    },
    read_single({ commit }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}${id}`)
          .then((result) => {
            commit('read_single_success', result.data.data``);
            commit('success');
            return resolve(result.data.data);
          }).catch((err) => {
            commit('error');
            console.log(err.response.data);
            return reject(err.response.data);
          });
      });
    },
    update({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api.request('put', `${API_UPDATE}${data.id}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },
    create({ commit }, { data }) {
      commit('request');

      return new Promise((resolve, reject) => {
        api.request('post', `${API_CREATE}`, {}, data)
          .then((response) => {
            commit('success');
            return resolve(response);
          }).catch((err) => {
            commit('error');
            return reject(err);
          });
      });
    },
  },
  getters: {
    injectPointMembers: () => state => state.injectPointMembers,
    pointplans: state => state.pointplans,
  }
}